<template>
    <div>
        <b-navbar toggleable="lg" class="bg-white nav-header">
            <b-navbar-brand href="/dashboard">
                <b-img src="/img/logo.png" class="nav-logo-img" alt="Logo" />
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse" />

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item v-for="navItem in navItems[selectedView]
                        ? navItems[selectedView].children
                        : CONSTANTS.COMMON_NAV" :key="navItem.url" :to="navItem.url"
                        v-if="checkUserFunction(navItem.permissions)">{{ navItem[locale] }}</b-nav-item>
                    <div v-if="!!currentUserDetail" class="mx-3 font-20 d-md-down-none">|</div>
                    <b-nav-item-dropdown right v-if="!!currentUserDetail">
                        <template #button-content>
                            <i class="fa fa-user mr-1" aria-hidden="true" id="nav-profile"></i>
                            {{ currentUserDetail ? currentUserDetail.name : '' }}
                            <b-tooltip target="nav-profile" placement="bottom">{{
                                $t('topMenu.userProfile')
                            }}</b-tooltip>
                        </template>
                        <b-dropdown-item @click="openUpdateProfileInfoModal" class="bg-white">
                            <i class="fa fa-user text-primary"></i>
                            {{ $t('topMenu.updateProfile') }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="openChangePassModal" class="bg-white">
                            <i class="fa fa-wrench text-primary"></i>
                            {{ $t('topMenu.changePassword') }}
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="logout" class="bg-white">
                            <i class="fa fa-sign-out text-primary"></i>
                            {{ $t('topMenu.logout') }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <div v-if="!!currentUserDetail" class="mx-3 font-20 d-md-down-none">|</div>
                    <b-nav-item-dropdown right v-if="!!currentUserDetail">
                        <template #button-content>
                            <i v-if="selectedView" :class="navItems[selectedView].iconClass" class="mr-1"
                                aria-hidden="true" id="view-change"></i>
                            <i v-else class="fa fa-home mr-1" aria-hidden="true"></i>
                            <b-tooltip target="view-change" placement="bottom">{{
                                $t('topMenu.changeView')
                            }}</b-tooltip>
                        </template>

                        <!-- Dropdown -->
                        <b-dropdown-item @click="changeView(view)" class="bg-white"
                            v-for="view in Object.keys(navItems)" v-if="checkUserFunction(navItems[view].permissions)"
                            :key="view" :active="view === selectedView">
                            <i :class="navItems[view].iconClass" class="text-dark" aria-hidden="true"></i>
                            {{ navItems[view].name[locale] }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-button v-if="!currentUserDetail" pill class="ml-3" @click="openLoginForm" variant="primary">Đăng
                        nhập</b-button>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <!-- the modal -->
        <!-- Update profile modal -->
        <b-modal ref="updateProfileInfo" :title="$t('updateProfileModal.title')" no-close-on-esc no-close-on-backdrop
            :cancel-title="$t('common.cancel')" @ok="handleUpdateProfileOk">
            <form @submit.prevent="submitUpdateProfileForm">
                <b-form-group :label="$t('updateProfileModal.fullName')">
                    <b-form-input maxlength="255" v-model="profileInfo.name"
                        :placeholder="$t('updateProfileModal.fullName')" name="fullName" v-validate="'required'"
                        :data-vv-as="$t('updateProfileModal.fullName')"></b-form-input>
                    <div v-show="errors.has('fullName')" class="validation-message text-danger">
                        {{ errors.first('fullName') }}
                    </div>
                </b-form-group>
            </form>
        </b-modal>

        <!-- Change password modal -->
        <b-modal ref="changePassModal" :title="$t('changePassModal.title')" no-close-on-esc no-close-on-backdrop
            :cancel-title="$t('common.cancel')" @ok="handleChangePassOk">
            <form @submit.prevent="submitChangePassForm">
                <b-form-group :label="$t('changePassModal.currentPass')">
                    <b-form-input maxlength="255" v-model.trim="changePassInfo.oldPassword"
                        :placeholder="$t('changePassModal.currentPass')" name="oldPassword" v-validate="'required'"
                        :data-vv-as="$t('changePassModal.currentPass')" type="password"
                        autocomplete="off"></b-form-input>
                    <div v-show="errors.has('oldPassword')" class="validation-message text-danger">
                        {{ errors.first('oldPassword') }}
                    </div>
                </b-form-group>

                <b-form-group :label="$t('changePassModal.newPass')">
                    <b-form-input maxlength="255" v-model.trim="changePassInfo.newPassword"
                        :placeholder="$t('changePassModal.newPass')" name="newPassword" v-validate="'required'"
                        :data-vv-as="$t('changePassModal.newPass')" type="password" ref="newPassword"
                        autocomplete="off"></b-form-input>
                    <div v-show="errors.has('newPassword')" class="validation-message text-danger">
                        {{ errors.first('newPassword') }}
                    </div>
                </b-form-group>

                <b-form-group :label="$t('changePassModal.confirmedPass')">
                    <b-form-input maxlength="255" v-model.trim="confirmedPassword"
                        :placeholder="$t('changePassModal.confirmedPass')" name="confirmedPassword"
                        v-validate="'required|confirmed:newPassword'" :data-vv-as="$t('changePassModal.confirmedPass')"
                        type="password" autocomplete="off"></b-form-input>
                    <div v-show="errors.has('confirmedPassword')" class="validation-message text-danger">
                        {{ errors.first('confirmedPassword') }}
                    </div>
                </b-form-group>
            </form>
        </b-modal>
        <!-- Login modal -->
        <b-modal ref="loginModal" hide-footer hide-header>
            <LoginForm @loginSuccess="loginSuccess" />
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import CONSTANTS from '../constants';
import { i18n } from '../main';
import navItems from '@/nav';
import LoginForm from '@/components/LoginForm';

export default {
    components: {
        LoginForm
    },
    mounted: function () {
        this.$nextTick(async function () {
            this.onRouteChange();
        });
    },
    data() {
        return {
            CONSTANTS,
            changePassInfo: {},
            profileInfo: {},
            navItems,
            selectedView: null,
            confirmedPassword: null,
            code: null
        };
    },
    computed: {
        ...mapState({
            currentUserDetail: state => cloneDeep(get(state.auth, 'currentUser.userDetail')),
            currentUser: state => cloneDeep(state.auth.currentUser)
        }),
        locale() {
            return i18n.locale;
        }
    },
    watch: {
        $route(val) {
            this.onRouteChange();
        }
    },
    methods: {
        ...mapActions({
            getCurrentUserDetail: 'auth/getCurrentUserDetail',
            actionLogout: 'auth/actionLogout',
            actionChangePass: 'auth/actionChangePass',
            updateProfileInfo: 'user/updateUserInfo',
            updateAuthState: 'auth/updateState',
            createAuditByUser: 'user/createAuditByUser'
        }),
        async logout() {
            await this.createAuditByUser({ content: 'Đăng xuất hệ thống' });
            await this.actionLogout();
            this.selectedView = null;
            this.$router.push('/');
        },
        openLoginForm() {
            this.$refs.loginModal.show();
        },
        loginSuccess(data) {
            if (data) {
                this.$refs.loginModal.hide();
                this.$router.push('/');
            }
        },
        // Change password
        openChangePassModal() {
            // Reset form
            this.changePassInfo = {};
            this.confirmedPassword = null;

            this.$refs.changePassModal.show();
        },

        handleChangePassOk(modal) {
            // Prevent modal from closing
            modal.preventDefault();
            // Trigger submit handler
            this.submitChangePassForm();
        },
        submitChangePassForm: function () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.actionChangePass(this.changePassInfo).then(() => {
                        this.$toaster.success(this.$t('changePassModal.changePassSuccessMsg'));
                        this.createAuditByUser({ content: 'Đổi mật khẩu' });
                        this.$refs.changePassModal.hide();
                    });
                }
            });
        },
        // Update Profile
        openUpdateProfileInfoModal() {
            // Reset form
            this.profileInfo = { ...this.currentUserDetail };
            this.$refs.updateProfileInfo.show();
        },
        handleUpdateProfileOk(modal) {
            // Prevent modal from closing
            modal.preventDefault();
            // Trigger submit handler
            this.submitUpdateProfileForm();
        },
        submitUpdateProfileForm: function () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.updateProfileInfo(this.profileInfo).then(() => {
                        this.$refs.updateProfileInfo.hide();
                        this.createAuditByUser({ content: 'Cập nhật thông tin cá nhân' });
                        this.$toaster.success(
                            this.$t('updateProfileModal.updateProfileSuccessMsg')
                        );
                        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                        currentUser.userDetail = { ...this.profileInfo };
                        localStorage.setItem('currentUser', JSON.stringify(currentUser));
                        this.getCurrentUserDetail();
                    });
                }
            });
        },
        checkUserFunction(functionList) {
            const userFunctions = get(this.currentUserDetail, 'functions');
            let hasPermission = false;
            if (functionList && userFunctions) {
                functionList.forEach(functionName => {
                    hasPermission = hasPermission || userFunctions.indexOf(functionName) > -1;
                });
                return hasPermission;
            }
            return true;
        },
        changeView(view) {
            this.selectedView = view;
            this.$router.push(`/home?view=${view}`);
            this.updateAuthState({
                stateName: 'currentUser',
                value: { ...this.currentUser, selectedView: view }
            });
        },
        onRouteChange() {
            Object.keys(navItems).forEach(view => {
                // TODO: find better way to check 2 routes matching
                const index = navItems[view].children.findIndex(
                    navItem => this.$route.path.indexOf(navItem.url) > -1
                );
                if (index > -1) {
                    this.selectedView = view;
                    this.updateAuthState({
                        stateName: 'currentUser',
                        value: { ...this.currentUser, selectedView: view }
                    });
                    return;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.nav-logo-img {
    max-height: 70px;
}

.nav-header {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);

    .navbar-nav .nav-item .nav-link {
        color: #000;
        text-decoration: none;
        font-weight: 700;
        text-transform: uppercase;
        padding: 15px;
    }
}

@media screen and (min-width: 1024px) {
    .nav-header {
        height: 70px;

        .navbar-nav {
            align-items: center;
        }

        .nav-logo-img {
            height: 60px;
        }
    }
}

@media screen and (max-width: 768px) {
    .nav-header {
        .navbar-brand {
            height: 60px;

            .nav-logo-img {
                height: 50px;
            }
        }

        .navbar-nav {
            align-items: center;
        }
    }
}
</style>
